import React from 'react'
import Skeleton from '@mui/material/Skeleton'

function DashCardComp({ img, title, sub, bool, leadBalance, loading }) {
  return (
    <div className=' p-4 flex gap-3 border border-[#D2D3D5] rounded-lg'>
      <div className=' pt-1'>
        <img src={img} alt='cardimg' />
      </div>
      <div>
        <p className=' text-[#1A1A1B] text-[14px] mb-1'>{title}</p>
        <div className=' text-back-color2 font-[500] text-[24px] mb-3'>
          {loading ? <Skeleton variant="text" width={100} height={40} /> : `₦ ${sub}`}
        </div>
        {bool && <div className=' flex justify-between'>
          <p className=' text-[#1A1A1B] text-[12px] mb-1'>Ledger Balance:  </p>
          <div className=' text-back-color2 font-[800] text-[14px] mb-3'>
            {loading ? <Skeleton variant="text" width={80} height={20} /> : `₦${leadBalance}`}
          </div>
        </div>}
      </div>
    </div>
  )
}

export default DashCardComp